<template>
  <v-dialog
    v-model="getModalExcluirCrmProposta"
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title>Excluir</v-card-title>
      <v-card-text>
        <h3 align="center">Tem certeza que deseja excluir?</h3>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="default"
          @click="setModalExcluirCrmProposta(false)"
          outlined
          :loading="$store.getters.getOverlay"
          >Voltar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          @click="excluirCrmProposta(getCrmProposta)"
          outlined
          :loading="$store.getters.getOverlay"
          >Excluir</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["getModalExcluirCrmProposta", "getCrmProposta"]),
  },
  methods: {
    ...mapActions(["excluirCrmProposta", "setModalExcluirCrmProposta"]),
  },
};
</script>